import { PostAPI } from 'Components/Helper/Helpers';

export const SelectLast10Request = async (request) => {
    return PostAPI(request, 'Overdraft/SelectLast10Request');
};

export const RequestInsert = async (request) => {
    return PostAPI(request, 'Overdraft/RequestInsert');
};

export const SelectRequestByFilter = async (request) => {
    return PostAPI(request, 'Overdraft/RequestReport');
};

export const SelectRequestByID = async (request) => {
    return PostAPI(request, 'Overdraft/SelectRequestByID');
};

export const RequestAction = async (request) => {
    return PostAPI(request, 'Overdraft/AcceptReject');
};

export const Reverse = async (request) => {
    return PostAPI(request, 'Overdraft/Reverse');
};

export const SelectReverseByFilter = async (request) => {
    return PostAPI(request, 'Overdraft/SelectReverseReport');
};

export const SelectReverseByID = async (request) => {
    return PostAPI(request, 'Overdraft/SelectReverseByID');
};

export const TransferReport = async (request) => {
    return PostAPI(request, 'Overdraft/TransferReport');
};

export const OverdraftSelectAll = async (request) => {
    return PostAPI(request, 'Overdraft/SelectRolewiseOverdraftUser');
};

export const Activate = async (request) => {
    return PostAPI(request, 'Overdraft/OverdraftActiveDeactive');
};

export const Update = async (request) => {
    return PostAPI(request, 'Overdraft/Update');
};

export const Delete = async (request) => {
    return PostAPI(request, 'Overdraft/Delete');
};
